export default __webpack_public_path__ + "static/media/appstore.c36e489d.jpeg";